/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_OrganizationInputs */

const en_page_title_organization = /** @type {(inputs: Page_Title_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

const nl_page_title_organization = /** @type {(inputs: Page_Title_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisatie`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Page_Title_OrganizationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_organization = /** @type {((inputs?: Page_Title_OrganizationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_OrganizationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_organization(inputs)
	return en_page_title_organization(inputs)
});